import gql from 'graphql-tag';

export const GetCTGLoyaltyIdByEmail = gql`
  query ctgLoyaltyIdByEmail($email: String!) {
    ctgLoyaltyIdByEmail(email: $email)
  }
`;
